import { abilitiesPlugin } from '@casl/vue';
import Buefy from 'buefy';
import { dateHelperService } from '@/services/date-helper-service';

import Vue from 'vue';
import Verte from 'verte';

import ability from './ability';
import App from './App.vue';
import router from './router';
import store from './store';

Vue.component('verte', Verte); // register component globally
Vue.use(Buefy, {
    defaultIconPack: 'fas'
});
Vue.filter('formatDate', dateHelperService.formatForClient);
Vue.filter('customDateFormat', (value, formatString) => {
    formatString = formatString || 'DD-MM-YYYY'; // Default format
    return dateHelperService.customFormat(value, formatString);
});

// Initialize Vue with user role abilities.
// This is required here otherwise a user will lose abilities when refreshing the app.
// `ability[role]` must use our custom subjectName function defined in ability.js.
// Ability permissions get updated once users login.
const role = localStorage.getItem('role') || 'Unauthorised';
Vue.use(abilitiesPlugin, ability[role]);

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
